// First API Layer of reinsurance
import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  RI_LOADING, RI_SUCCESS,
  RI_FAIL,
  RI_LISTING_LOADING,
  RI_LISTING_SUCCESS,
  RI_LISTING_FAIL,
  RI_DETAIL_LOAD_DATA,
  RI_AUTOCESSION_INIT_LOADING,
  RI_AUTOCESSION_INIT_SUCCESS,
  RI_AUTOCESSION_INIT_FAIL
} from '@/store/types'
import { RI_DETAIL_LISTING_LOADING } from '../../../types'

export const general = {
  async riOutInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.reinsurance
    if (apiUrl) {
      commit(RI_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(RI_SUCCESS, commitResult)
      } catch (error) {
        commit(RI_FAIL, extractMessages(error))
      }
    } else {
      commit(RI_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async riOutListingInit({ commit, state }) {
    const apiUrl = state.menu.riListing
    if (apiUrl) {
      commit(RI_LISTING_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(RI_LISTING_SUCCESS, commitResult)
      } catch (error) {
        commit(RI_LISTING_FAIL, extractMessages(error))
      }
    } else {
      commit(RI_LISTING_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async riDetailInit({ commit, state }) {
    const apiUrl = state.riListing.menu.getRiLists
    if (apiUrl) {
      commit(RI_DETAIL_LISTING_LOADING)
    }
  },
  async loadReinsurance({ commit, state }, data) {
    try {
      const expand = {
        polNo: data.polNo.polNo,
        renCnt: data.polNo.renCnt,
        endtCnt: data.polNo.endtCnt
      }
      const result = await http.get(expandURI(state.riOutListing.menu.getRiPolMaster, expand))
      if (result.data) {
        const commitResult = {
          data: result.data,
          query: data.query
        }
        commit(RI_DETAIL_LOAD_DATA, commitResult)
      } else {
        throw new Error('Invalid Fetch Result')
      }
    } catch (err) {
      throw err
    }
  },
  async riAutoCessionInit({ commit, state }) {
    const apiUrl = this.state.app.menu.riAutoCession
    if (apiUrl) {
      commit(RI_AUTOCESSION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(RI_AUTOCESSION_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(RI_AUTOCESSION_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(RI_AUTOCESSION_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  }
}
